import React from 'react';
import { MdDescription, MdAssessment } from 'react-icons/md';
import '../ProvasProcesso/ProvaSettings.css';

const enabled = value => value === true || value === 1 || value === '1' || value === 'true';
const answer = value => value == null ? 'Não informado' : enabled(value) ? 'Sim' : 'Não';

export default function RedacaoSettings({ redacao }) {
  const online = enabled(redacao.processo?.online);
  const groups = [
    { title: 'Folha de redação', icon: MdDescription, color: 'purple', rows: [
      ...(online ? [['Campo de título', answer(redacao.show_titulo)]] : []),
      ['Número de linhas', redacao.number_lines ?? 'Não informado'],
    ] },
    ...(online ? [{ title: 'Ao finalizar a redação', icon: MdAssessment, color: 'green', rows: [
      ['Mostrar folha de resposta', answer(redacao.folha_resposta)],
      ['Mostrar correção', answer(redacao.show_correcao)],
    ] }] : []),
  ];
  return <section className="prova-settings" aria-label="Configurações da redação">
    <h2>Configurações da redação</h2>
    <div className="prova-settings-grid">{groups.map(group => {
      const Icon = group.icon;
      return <div className="prova-settings-group" key={group.title}>
        <h3><span className={`prova-settings-icon is-${group.color}`}><Icon aria-hidden="true" /></span>{group.title}</h3>
        <dl>{group.rows.map(([label, value]) => <div className="prova-settings-row" key={label}><dt>{label}</dt><dd>{value}</dd></div>)}</dl>
      </div>;
    })}</div>
  </section>;
}
